// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3xd9j","addWidgetButton":"Header_addWidgetButton__cfQW2","dashboardTabs":"Header_dashboardTabs__1rpyw","active":"Header_active__3rwLo"};